export default "__VITE_ASSET__DbowhXNj__"